SP.ProductQuickviewBundle = Garnish.Base.extend({
    parent: null, // Product tile
    $triggerBtn: null, // Button that triggered this quickview

    // Dom
    $container: null,
    $form: null,
    $productTitle: null,
    $productPrice: null,
    $productOriginalPrice: null,
    $productDescription: null,
    $productLearnMoreLink: null,
    $productSelectInput: null,
    $productOptions: null,
    $cartAddBtn: null,
    $cartResponse: null,
    $mediaSliderContainer: null,
    $mediaSlider: null,

    // Quantity Elements
    $qtyBtn: null,
    $qtyInput: null,
    currentQty: 1,

    // Product
    product: null,

    // Variant
    defaultVariant: false,
    variant: null,

    // Options
    selectedOptions: '',
    selectedMediaId: null,

    // Modal Components
    $modal: null,
    modal: null,
    imagesLoaded: false,
    initialSliderLoad: true,
    mediaSlider: null,

    init(btn, parent) {
        this.parent = parent
        this.$triggerBtn = $(btn)

        // Product & first or default variant Instance
        this.product = this.parent.$el.find('.product-data').data('product')
        this.variant = this.product.variants[0]

        // Modal Components
        this.createDomElements()
    },

    createDomElements() {
        this.$container = $('#quick-view')

        if (this.$container.length === 0) {
            this.$container = $('<div id="quick-view"/>').appendTo($('body'))
        }

        // Inject global variable quickviewcontent into container
        this.$container.html(QuickviewMarkup)

        this.$form = this.$container.find('#AddToCartForm')
        this.$mediaSliderContainer = this.$container.find('.product-images')
        this.$mediaSlider = this.$container.find('.quick-view-image-slider')
        this.$productTitle = this.$container.find('.product-title')
        this.$productDescription = this.$container.find('.product-description')
        this.$productPrice = this.$container.find('.product-price')
        this.$productOriginalPrice = this.$container.find('.product-original-price')
        this.$productOptions = this.$container.find('.product-options')
        this.$productLearnMoreLink = this.$container.find('.more-info-link')
        this.$cartResponse = this.$container.find('.add-to-cart-response')
        this.$qtyBtn = this.$container.find('.update-qty')
        this.$qtyInput = this.$container.find('#quantity')
        this.$cartAddBtn = this.$container.find('#add-to-cart')

        this.$cartAddBtn.html('Add to bundle')

        // Fetch and populate container with product data
        this.fetchProductDetails()
    },

    fetchProductDetails() {
        window.UI.createLoader()

        $.ajax({
            url: `/products/${this.product.handle}.js`,
            dataType: 'json'
        })
            .done($.proxy(this, 'doneFetchingProduct'))
            .fail($.proxy(this, 'failedFetchingProduct'))
            .always($.proxy(this, 'completeFetchingProduct'))
    },

    doneFetchingProduct(product) {
        ga('send', 'event', 'Collection', 'Quickview Click', this.product.title)

        this.product = product
        this.createProductDetails()
        this.createProductOptions()
        this.fetchProductMedia()
        this.createModal()
        this.activateVariantSelector()

        this.setupEvents()
    },

    setupEvents() {
        this.addListener(this.$form, 'submit', this.processCart)
        this.addListener(this.$qtyBtn, 'click', this.handleQuantitySelector)
        this.addListener(this.$qtyInput, 'change', this.verifyQtyChange)
    },

    failedFetchingProduct(jqXHR, textStatus, errorThrown) {
        toastr.error('Error opening quickview, please try again later.', 'Error')
    },

    completeFetchingProduct() {
        window.UI.removeLoader()
    },

    createProductDetails() {
        let price = 0
        let original_price = 0

        price = Shopify.formatMoney(this.product.price, '')
        original_price = Shopify.formatMoney(this.product.compare_at_price, '')

        this.$productTitle.html(this.product.title)
        this.$productDescription.html(this.product.description)
        this.$productPrice.html(price)
        this.$productLearnMoreLink.attr('href', this.product.url)

        if (this.product.compare_at_price) {
            this.$productPrice.addClass('sale-price')
            this.$productOriginalPrice.html(original_price).addClass('crossed-out')
        } else {
            this.$productPrice.removeClass('sale-price')
            this.$productOriginalPrice.html('')
        }
    },

    createProductOptions() {
        let self = this
        let variants = this.product.variants
        let options = this.product.options

        // Default Variant Selector
        this.$productSelectInput = $(`<select id="product-select" name="id" tabindex="-1" class="visuallyhidden" aria-hidden="true" />`)
        for (let i = 0; i < variants.length; ++i) {
            this.$productSelectInput.append($(`<option aria-disabled="true" value="${variants[i].id}" >${variants[i].title} - ${Shopify.formatMoney(variants[i].price, '')}</option>`))
        }

        this.$form.prepend(this.$productSelectInput)

        this.addListener(this.$productSelectInput, 'change', this.handleProductSelect)

        // Product Options
        let $optionElements = []

        $(options).each(function (i, option) {
            let index = i
            let optionName = option.name;
            let optionSlug = slugify(optionName)

            let $optionEl = $(`<div role="radiogroup" aria-label="${optionName}" class="product-option ${optionSlug}-options" />`)

            self.$productOptions.append($optionEl)

            if (optionSlug === 'color') {
                let tempColors = []

                $(variants).each(function (i, variant) {
                    let color = variant.options[index]
                    let colorHandle = slugify(color)
                    let availableClass = variant.available ? 'available' : 'not-available'
                    let cdnUrl = 'https://cdn.shopify.com/s/files/1/0330/3299/4860/files/'
                    let colorImage = cdnUrl + colorHandle + '.png'
                    let imageId = null

                    if (variant.featured_image) {
                        imageId = variant.featured_image.id
                    }

                    if ($.inArray(color, tempColors) === -1) {
                        self.$productOptions.find(`.${optionSlug}-options`).append(`<div role="radio" tabindex="-1" aria-checked="false" class="${availableClass} ${optionSlug}-option ${colorHandle}-option has-color" data-available="${variant.available}" data-option-name="${optionName}" data-variant-name="${color}" data-variant-id="${variant.id}" data-media-id="${imageId}" data-option-value="${color}"><span class="color-option" aria-label="${color}" style="background-image: url(${colorImage});"></span></div>`)
                    }

                    tempColors.push(color)
                })
            } else {
                if (self.product.variants.length > 1) {
                    let tempArray = []

                    $(self.product.variants).each(function (i, variant) {
                        let opt = variant.options[index]
                        let optHandle = slugify(opt)
                        let availableClass = variant.available ? 'available' : 'not-available'
                        let imageId = null

                        if (variant.featured_image) {
                            imageId = variant.featured_image.id
                        }

                        if ($.inArray(opt, tempArray) === -1) {
                            self.$form.find(`.${optionSlug}-options`).append(`<div role="radio" tabindex="-1" aria-checked="false" class="${availableClass} ${optionSlug}-option ${optHandle}-option" data-available="${variant.available}" data-option-name="${optionName}" data-variant-name="${opt}" data-variant-id="${variant.id}" data-media-id="${imageId}" data-option-value="${opt}">${opt}</div>`)
                        }

                        tempArray.push(opt)
                    })
                } else {
                    self.defaultVariant = true
                    self.$productSelectInput.val(self.variant.id).trigger('change')
                }
            }

            $optionElements.push($optionEl)
        })

        for (let i = 0; i < $optionElements.length; ++i) {
            new SP.OptionRadioGroup($optionElements[i][0], this)
        }
    },

    fetchProductMedia() {
        let self = this

        $.getJSON('/products/' + this.product.handle + '.json', function (res) {
            let images = res.product.images
            let imageCount = $(images).length

            $(images).each(function (i, image) {
                let image_embed = '<li class="swiper-slide" data-index="' + i + '" data-slider-image-id="' + image.id + '"><img src="' + image.src + '" alt="' + image.alt + '"></li>'

                if (i === imageCount - 1) {
                    image_embed = image_embed.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png')
                    $('.swiper-wrapper').append(image_embed)
                } else {
                    image_embed = '<li class="swiper-slide" data-index="' + i + '" data-slider-image-id="' + image.id + '"><img src="' + image.src + '" alt="' + image.alt + '"></li>'
                    image_embed = image_embed.replace('.jpg', '_600x.jpg').replace('.png', '_600x.png');
                    $('.swiper-wrapper').append(image_embed)
                }
            })

            self.imagesLoaded = true

            if (imageCount > 0) {
                self.createMediaSlider()
            } else {
                self.$container.addClass('no-media')
            }
        })
    },

    handleProductSelect() {
        let variantId = this.$productSelectInput.val()
        this._setVariant(variantId)

        this.updateProductSlide()
        this.updateProductForm()
    },

    updateProductSlide() {
        if (this.variant.featured_image) {
            let imageId = this.variant.featured_image.id
            let slide = $(`[data-slider-image-id="${imageId}"]`)

            if (slide.length > 0) {
                let slideIndex = slide.data('swiper-slide-index')
                this.mediaSlider.slideTo(slideIndex + 1)
            }
        }
    },

    updateProductForm() {
        // Check if variant is available
        if (this.variant.available) {
            this.$cartAddBtn.prop('disabled', false).html('Add To Bundle').removeClass('btn-disabled').attr('aria-disabled', false)
        } else {
            this.$cartAddBtn.prop('disabled', true).html('Sold Out').addClass('btn-disabled').attr('aria-disabled', true)
        }
        // Update price
        // $('#quick-view .product-price').html(`${Shopify.formatMoney(this.selectedVariant.price, '')}`)
    },

    createModal() {
        let self = this

        this.modal = $.fancybox({
            href: '#quick-view',
            maxWidth: 1300,
            fitToView: true,
            width: '60%',
            height: '100%',
            autoSize: true,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            scrolling: 'no',
            helpers: {
                overlay: {
                    locked: false
                }
            },
            'beforeLoad': function () {
                // self.handleAddToCart()
            },
            'afterShow': function () {
                self.$container.addClass('active')
                window.UI.removeLoader()
                // self.createMediaSlider()
            },
            'afterClose': function () {
                self.$container.removeClass().empty()
            },
            'onUpdate': function () {
                let laptopWidth = 768
                let winWidth = $(window).outerWidth()
            }
        })
    },

    createMediaSlider() {
        let self = this

        this.mediaSlider = new Swiper(this.$mediaSlider, {
            direction: 'horizontal',
            loop: true,
            mousewheel: true,
            autoHeight: true,
            height: 450,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                320: {
                    direction: 'horizontal',
                    height: 400,
                },
                769: {
                    direction: 'vertical',
                    height: 580,
                },
                1800: {
                    direction: 'vertical',
                    height: 580,
                },
            },
            on: {
                init: function () {
                    // self.activateVariantSelector(this)
                }
            }
        })

        setTimeout(function () {
            self.$mediaSliderContainer.addClass('images-loaded')
        }, 100)
    },

    activateVariantSelector() {
        let self = this

        // Add active classes to first options
        let $optionsEl = this.$productOptions.children().find('> div:eq(0)')
        $.each($optionsEl, function (i, el) {
            let target = $(el)
            target.addClass('active-option')
        })

        this.setVariantObject()

        // Click event for options
        this.$productOptions.find('.product-option > div').on('click', function () {
            self.$cartResponse.html('').removeClass('has-error').removeClass('has-success')

            let optionTitle = $(this).data('option-name')
            let variantTitle = $(this).data('variant-name')

            $(`.${slugify(optionTitle)}-option`).removeClass('active-option')
            $(this).addClass('active-option')

            self.setVariantObject()

            self.variant = self.product.variants.find(v => v.title === self.selectedOptions)

            // This updates add to cart button if variant is available or not (sold out)
            self.verifyVariantAvailability()
        })

    },

    verifyVariantAvailability() {
        let price = Shopify.formatMoney(this.variant.price, '')
        let original_price = Shopify.formatMoney(this.variant.compare_at_price, '')

        this.$productPrice.html(price)

        if (this.variant.compare_at_price) {
            this.$productPrice.addClass('sale-price')
            this.$productOriginalPrice.html(original_price).addClass('crossed-out')
        } else {
            this.$productPrice.removeClass('sale-price')
            this.$productOriginalPrice.html('')
        }

        if (this.variant.inventory_management === null) {
            this.$cartAddBtn.prop('disabled', false).html('Add to cart')
            this.$cartAddBtn.removeClass('btn-disabled')
        } else {
            if (!this.variant.available) {
                this.$cartAddBtn.prop('disabled', true).html('Sold Out')
                this.$cartAddBtn.addClass('btn-disabled')
            } else {
                this.$cartAddBtn.prop('disabled', false).html('Add to cart')
                this.$cartAddBtn.removeClass('btn-disabled')
            }
        }
    },

    handleQuantitySelector(e) {
        let type = $(e.currentTarget).data('type')
        this.currentQty = parseInt(this.$qtyInput.val())

        if (type === 'increase') {
            this.increaseQuantity()
        }

        if (type === 'decrease') {
            this.decreaseQuantity()
        }
    },

    processCart(e) {
        let self = this
        e.preventDefault()

        this.$cartResponse.html('').removeClass('has-error').removeClass('has-success')
        $.fancybox.close()
        window.bundleApp.$children[0].addProductToBundleFromQuickView(this.product.id, parseInt(this.$qtyInput.val()))
        return false
    },

    setVariantObject() {
        let self = this
        let selectedOption = []
        let $selectedOptionEl = this.$productOptions.find('.active-option')
        this.selectedOptions = ''

        $.each($selectedOptionEl, function (i, el) {
            let target = $(el)

            selectedOption.push({
                id: target.data('variant-id'),
                mediaId: target.data('media-id'),
                value: target.data('option-value')
            })
        })

        $.each(selectedOption, function (i, option) {
            if (self.selectedOptions !== '') {
                self.selectedOptions = self.selectedOptions + ' / ' + option.value
            } else {
                self.selectedOptions = option.value
            }
        })
    },

    verifyQtyChange() {
        if (this.currentQty <= 0) {
            this.$qtyInput.val(1)
        }
    },

    increaseQuantity() {
        this.$qtyInput.val(this.currentQty + 1)
    },

    decreaseQuantity() {
        if (this.currentQty === 1) {
            this.$qtyInput.val(1)
        } else {
            this.$qtyInput.val(this.currentQty - 1)
        }
    },

    _setVariant(variantId) {
        this.variant = this.product.variants.find(v => v.id === parseInt(variantId))
    }
})

/**
 * Slugify function
 */

function slugify(text) {
    return text.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-')
}